import { ReactElement } from "react";
import { Route, Redirect, RouteProps } from "react-router-dom";
import { useDependency } from "../../../contexts/DependencyContext";
import { TimeMachineContextProvider } from "../../../contexts/TimeMachineContext";
import { LoginService } from "../../../services/LoginService";

const PrivateRoute = (props: RouteProps): ReactElement =>
{
    const loginService = useDependency(LoginService);

    return (loginService.isAuthenticated() === true
        ? <TimeMachineContextProvider>
            <Route {...props} />
        </TimeMachineContextProvider>
        : <Redirect to='/login' />);
}

export default PrivateRoute;